import axios from "axios";
import Vue from "vue"
import {
	Message,
	MessageBox,
	Notification
} from 'element-ui'

import VueRouter from 'vue-router'
import routes from '@/config/AppRoutes'
const router = new VueRouter({
	mode: 'history',
	base: "",
	routes
})

import jsCookie from 'js-cookie'

import {
	message
} from '@/utils/resetMessage';

import {
	setbaseurl
} from "@/utils/utils"

import {
	getToken
} from '@/utils/auth'

// console.log(window,"httpwindow")
/****** 创建axios实例 ******/
// 开发地址 192.168.88.136
// 生产地址，101.34.17.168:8091


// 根据请求生成对应的key
function generateReqKey(config, hash) {
	const {
		method,
		url,
		params,
		data
	} = config;
	return [method, url, JSON.stringify(params), JSON.stringify(data), hash].join("&")
}
// 存储已发送但是没有响应的请求
const pendingRequest = new Set();



var baseURL = ""

baseURL = window.myURL.URL

const service = axios.create({
	baseURL: baseURL, // api的base_url
	timeout: 20000 // 请求超时时间
});


// console.log(service.baseURL,"请求里面的")
/****** request拦截器==>对请求参数做处理 ******/

service.interceptors.request.use(
	config => {
		// console.log(config, "提交请求")
		// config.headers["Content-Type"] = "multipart/form-data"
		if (getToken() && getToken().length > 30) {
			config.headers['Authorization'] = getToken()
		} else if (jsCookie.get("Token")) {
			config.headers['Authorization'] = "Bearer " + jsCookie.get("Token").split("&")[0].split("=")[1];
		}


		// 在发送请求之前做些什么
		if (config.method === 'get') {

			// 处理 GET 请求
			config.params = {
				...config.params
			};
		}


		if (config.data instanceof FormData) {
			// 是FormData类型
			config.headers["Content-Type"] = 'multipart/form-data'
		} else {
			// 不是FormData类型
			config.headers["Content-Type"] = "application/json; charset=utf-8"
		}

		// console.log(config.responseType, "提交3123123")
		// 解决重复请求
		let hash = location.hash;
		// 生成请求key
		// let reqKey = generateReqKey(config, hash);
		// if (pendingRequest.has(reqKey)) {
		// 	return Promise.reject();
		// } else {
		// 	// 将请求的key保存在config
		// 	config.pendKey = reqKey;
		// 	pendingRequest.add(reqKey);
		// }

		return config
	},
	error => {
		// do something with request error
		// console.log(error) // for debug
		return Promise.reject(error)
	}
)

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1);
		if (c.indexOf(name) != -1) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}
// 响应拦截器
service.interceptors.response.use(response => {

	// 从config中取出请求key,并从集合中删除
	// pendingRequest.delete(response.config.pendKey);

	// console.log(response,'响应')
	const code = response.status
	const messages = response.data.msg
	const codes = response.data.code
	const datas = response.data.data
	// console.log(response, "响应正确")
	if (response.data.msg == "token值失效" && code == -2) {
		Message.error("用户信息过期，请重新登录！")

		localStorage.clear("token")
		localStorage.clear("siguid")
		localStorage.clear("uiguid")
		localStorage.clear()
		jsCookie.clear()
		location.href = '#/yunxuexipingtai/homesview/homesview'
		return
	}


	if (code == 200 && codes == -1) {
		// console.log(response)
		if (datas == -2) {

		} else {
			message(messages)
		}
		return response
	} else if (code !== 200) {
		return Notification.error({
			title: messages
		})
	}


	// console.log(response, "判断请求值响应错误")
	return response
}, error => {
	// pendingRequest.delete(error.config.pendKey);
	// 对响应错误做点什么
	// console.log(error, "响应错误")
	var codeas = error.response.status ?? ""
	var messagea = error.message ?? ""
	var codesb = error.response.data.code ?? ''

	if (error && error.message == "timeout of 10000ms exceeded") {
		Message.error('请求超时，正在刷新页面！！！')
		// window.location.reload()
	}


	if (codeas == 401) {
		// console.log('跳转到指定页面', codeas)
		// routes.push("/user/logins")
		// routerurl = router.resolve({
		// 	path: '/user/logins'
		// });
		// window.open(routerurl,'_self')
		if (localStorage.getItem('uiguid')) {
			localStorage.clear("token")
			localStorage.clear("siguid")
			localStorage.clear("uiguid")
			localStorage.clear()
			jsCookie.clear()

			location.href = '#/yunxuexipingtai/homesview/homesview'
		}

		// MessageBox.alert(
		// 	"用户登录信息已失效！！",
		// 	"系统提示", {
		// 		confirmButtonText: "重新登录",
		// 		type: "warning",
		// 		callback: action => {
		// 			// console.log(action)

		// 		}
		// 	}
		// )
	} else if (codeas == 500) {
		message("服务器错误，请联系管理员！！！")
	}

	if (codesb == -1) {
		jsCookie.remove("allbtnlist")
		// jsCookie.remove("/%password/%")
		// jsCookie.remove("/%name/%")
		jsCookie.remove("/%sxtrguid/%")
		jsCookie.remove("sxsi_guid")
		localStorage.clear("token")
		localStorage.clear("siguid")
		localStorage.clear("uiguid")
		jsCookie.remove("Token")
		routes.push("/user/logins")
		jsCookie.clear()
	}

	// Promise.reject(error)
	return error
})


// 返出
export default service